<template>
    <div class="result">
        <div class="result-title">
            <span class="sub-blue">{{index}}、</span>
            <div class="result-title-t sub-blue">{{data.categories_name}}</div>
            <div v-if="data.categories!=4"><span v-html="HTMLEncodes(data.question)"></span>({{data.pivot.score}}分)</div>
            <div v-else><span v-html="HTMLEncodes(data.question).split('（）')[0]"></span> ( <span style="color:#4D8EF6" v-html="HTMLEncodes(data.answer)"></span> ) <span v-html="HTMLEncodes(data.question).split('（）')[1]"></span>（{{data.pivot.score}}分）</div>
        </div>
        <ul class="result-topic" v-if="data.categories === 1 || data.categories === 2 || data.categories === 3">
            <li v-for="(item,key,i) in data.select" :key="i" :class="{'sele-li':!!(data.answer.indexOf(key)>=0 && $route.query.status == 1)}">{{key}} {{item}}</li>
        </ul>
        <div class="result-sh" v-if="data.categories === 5">
            <span style="color:#4D8EF6" v-html="HTMLEncodes(data.answer)"></span>
        </div>
        <div class="result-re">
            <div class="result-re-er">您的答案：<span>{{setMyResult(data)}}</span></div>
            <div class="result-re-su" v-if="(data.categories==4 || data.categories ==5) && $route.query.status == 1">正確答案：<span class="sub-blue"><span v-html="HTMLEncodes(setResult.explain || setResult.comment || data.answer)"></span></span></div>
            <div class="result-re-su" v-else-if="$route.query.status == 1">正確答案：<span class="sub-blue">{{data.categories === 2 ? data.answer.split('').join('、') : ''}}<span v-if="data.categories != 2" v-html="HTMLEncodes(data.answer)"></span></span></div>
            <div class="result-re-an" v-if="$route.query.status == 1">答案解析：<span v-html="HTMLEncodes(data.describe)"></span></div>
            <div class="result-re-hi" v-if="(data.categories==4 || data.categories ==5) && !rating_score"  :class="{'result-re1':setResult.result == 0}">{{setResult.result == 0?'您的回答錯誤！':'恭喜您回答正確！'}}</div>
            <div class="result-re-hi" v-else  :class="{'result-re1':!setResult}">{{setResult?'恭喜您回答正確！':'您的回答錯誤！'}}</div>
        </div>
        <slot></slot>
    </div>
</template>
<script>
import { HTMLEncode } from '@/utils'
export default {
    data(){
        return {
            radio: '',
            checkList:[],
            textarea:'',
        }
    },
    props:{
        data: {
            type: [Object],
            default:function(){
                return {}
            }
        },
        examData: {
            type: [Object],
            default:function(){
                return {}
            }
        },
        index: {
            type: [String, Number],
        },
        rating_score:{      //系统评卷
            type:[Boolean]
        }
    },
    computed:{
        setResult(){
            if(this.data.categories==4 || this.data.categories ==5){  //填空，简答
                if(this.examData.exam.status>0 && this.examData.exam.lecturer_evaluation){//考试人工评卷
                    var lecturer_evaluation=JSON.parse(this.examData.exam.lecturer_evaluation),
                        lecturer_evaluation=lecturer_evaluation[this.data.id];
                        return lecturer_evaluation;
                }
            }
            if(this.data.categories == 2){
                if (!this.examData.examHistoryQuestion[this.data.id] || !this.data.answer) {
                    return false;
                }
                const result= this.data.answer.toString().replace(/,/g,'')==this.examData.examHistoryQuestion[this.data.id].toString().replace(/,/g,'');
                return !!result;
            }else{
                return this.data.answer==this.examData.examHistoryQuestion[this.data.id];
            }
        }
    },
    methods:{
        HTMLEncodes(v){
            return HTMLEncode(v); 
        },
        setMyResult(data){
            if (this.examData.examHistoryQuestion[data.id] === null || this.examData.examHistoryQuestion[data.id] === '') {
                return '未填寫';
            }
            if (data.categories === 2) {
                return this.examData.examHistoryQuestion[data.id].toString().split(',').join('、');
            } else {
                return this.examData.examHistoryQuestion[data.id].toString();
            }
        },
    }
}
</script>
<style lang="less" scoped>
@blue:#4D8EF6;
.sub-blue{
    color:@blue
}

.result{
    &-title{
        display: flex;
        align-items: center;
        font-size:14px;
        color:rgba(51,51,51,1);
        &-t{
            border:1px solid @blue;
            padding: 6px 10px;
            border-radius: 4px;
            margin-left: 6px;
            white-space: nowrap;
            margin-right: 13px;
        }
    }
    &-topic{
        padding-left: 30px;
        color: #333333;
        font-size:14px;
        li{
            margin-top: 16px;
            padding: 2px 0;
        }
        .sele-li{
            color:rgba(77,142,246,1);
            background:rgba(77,142,246,0.1);
        }
    }
    &-re{
        background:rgba(244,244,249,1);
        margin-left: 30px;
        margin-top: 12px;
        padding: 18px;
        // box-sizing: border-box;
        font-size: 14px;
        &-su{
            margin-bottom: 22px;
            span{
                font-size:20px;
            }
        }
        &-an{
            margin-bottom: 22px;
            word-break: break-all;
        }
        &-er{
            margin-bottom: 22px;
            span{
                font-size:20px;
                color: #1AAD19;
            }
        }
        &-hi{
            width: 142px;
            height: 38px;
            line-height: 36px;
            border:2px solid rgba(26,173,25,1);
            background:rgba(26,173,25,0.15);
            border-radius:4px;
            text-align: center;
            font-size:14px;
            margin-bottom: 10px;
        }
    }
    &-re1{
        background:rgba(226,89,89,0.15);
        border:2px solid rgba(226,89,89,1);
    }
    &-sh{
        width:718px;
        height:90px;
        padding: 10px;
        background:rgba(255,255,255,1);
        border:1px solid rgba(234,234,243,1);
        border-radius:6px;
        margin-top: 21px;
        margin-left: 28px;
    }
}
</style>